(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxGoProfileListItem(
    PrinterListPOSTPaging, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        goProfile: '=goProfile',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
      },
      templateUrl: 'app/components/settings/printixGo/goProfileListItem/goProfileListItem.template.html',
      link: function(scope) {

        scope.pagedParams = new PrinterListPOSTPaging();
        scope.pageMetaData = new PrinterListPOSTPaging();

        (function() {
          scope.enableOnDevice = scope.tenant.info.enableOnDevice;
          getPrinterCount();
        })();

        function getPrinterCount() {
          scope.pageMetaData.pagingCriteria.pageSize = 1;
          scope.goProfile.getPrinters(scope.pageMetaData).then(function(printerListObject) {
            scope.totalPrinters = printerListObject.page.totalElements;
          }).catch(function(error) {});
        }

        scope.updateResources = function () {
          getPrinterCount();
        }

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Open contextueal dropdown
        ////////////////////////////////////
        scope.openGoProfileMenu = function(event, goProfile) {
          console.log('Enabled:', scope.enableOnDevice);
          scope.closeAllMenues();
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                {
                  title: 'DeleteSignInProfile', selected: false, type: 'deleteSignInProfile', breaker: true,
                  disabled: (scope.totalPrinters > 0 ? true : scope.enableOnDevice === 'SUSPENDED') || scope.me.isSystemObserver()
                },
                {
                  title: 'Properties', selected: false, type: 'link', breaker: true, href: '/admin/#/signInProfile/' + goProfile.id
                }
              ],
              context: goProfile,
              icon: 'icon-key-card2ai',
              sizeClass: 'size115',
              type: 'ALLROUND'
            }
            scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Open context menu
        ////////////////////////////////////
        scope.closeAllMenues = function (selectedContextMenuItem, contextXPosition, contextContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextPosition = null;
          scope.contextContent = null;
          $timeout(function () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextPosition = contextXPosition;
            scope.context = contextContent;
            scope.auxiliaries = {
              tenant: scope.tenant,
              goProfile: scope.goProfile
            }
          }, 50)
        }

      }
    };
  }

  pxGoProfileListItem.$inject = ['PrinterListPOSTPaging', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxGoProfileListItem', pxGoProfileListItem);

})();
